import { statusKeys as RS } from '../../helpers/projReportHelper';
import { status as PS } from '../../helpers/passport';
import {
  isAdmin, isStratAdmin, isPortfolioAdmin, isProjectAdmin,
} from '../rolesSvc';

const isStrategyTeam = ({ mine }, stratId) => mine.strategies && mine.strategies.find((p) => p.strategyId === parseInt(stratId));
const isPortfolioTeam = ({ mine }, portfolioId) => mine.portfolios && mine.portfolios.find((p) => (p.portfId === parseInt(portfolioId) || p.versionId === parseInt(portfolioId)));
const isProjectTeam = ({ mine }, projId) => mine.projs && mine.projs.find((p) => (p.projId === parseInt(projId) || p.versionId === parseInt(projId)));

const rules = {
  Read: {
    isStatusOk: (status) => true,
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => isProjectTeam(userCtx, projId) || isPortfolioTeam(userCtx, portfId) || isStrategyTeam(userCtx, stratId) || isAdmin(userCtx),
  },
  Edit: {
    isStatusOk: (status) => ![RS.expertsApproved, RS.expertsDeclined, RS.approved].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
    extra: (status, userCtx, stratId, projId, portfId, policyId) =>
      isAdmin(userCtx) // ПО редактирует всегда, кроме "Одобрено/Не одобрено ЭГ/Утвержден"
      || isStratAdmin(userCtx, stratId) && [RS.onApproveHeadSP].includes(status) // в статусе "На рассмотрении СП" редактировать может только СП
      || (isStratAdmin(userCtx, stratId) || isPortfolioAdmin(userCtx, portfId)) && [RS.onApprovePortf].includes(status) // в статусе "У руководителя портфеля" редактировать может только РПортф (и его РСП)
      || (isStratAdmin(userCtx, stratId) || isPortfolioAdmin(userCtx, portfId) || isProjectAdmin(userCtx, projId)) && [RS.inProgress, RS.returnedByPortf, RS.returnedByHeadSP, RS.returnedByExperts].includes(status),
    // РП и РСП могут редактировать на тех же статусах, что и РП (вместо него)
  },
  SendToPortf: {
    isStatusOk: (status) => [RS.inProgress, RS.returnedByHeadSP, RS.returnedByExperts, RS.returnedByPortf].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => stratId && portfId && (isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isAdmin(userCtx)),
  },
  PortfReturn: {
    isStatusOk: (status) => RS.onApprovePortf === status,
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => stratId && portfId && (isPortfolioAdmin(userCtx, portfId) || isAdmin(userCtx)),
  },
  SendToHead: {
    isStatusOk: (status) => [RS.inProgress, RS.onApprovePortf, RS.returnedByHeadSP, RS.returnedByExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => stratId && (isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx)),
    extra: (status, userCtx, stratId, projId, portfId, policyId) =>
      !portfId && status !== RS.onApprovePortf && (isAdmin(userCtx) || isStratAdmin(userCtx, stratId) || isProjectAdmin(userCtx, projId))
      || portfId && status === RS.onApprovePortf && (isPortfolioAdmin(userCtx, portfId) || isAdmin(userCtx)), // портфельные проекты отправляются к РСП только со стадии "У РПортф"
  },
  HeadSendToExperts: {
    isStatusOk: (status) => [RS.onApproveHeadSP].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => stratId && !portfId && (isStratAdmin(userCtx, stratId) || isAdmin(userCtx)), // портфельные проекты не отправляются на ЭГ, сразу одобряются РСП
  },
  HeadReturn: {
    isStatusOk: (status) => [RS.onApproveHeadSP].includes(status),
    isRoleOk: (userCtx, stratId, projId) => stratId && (isStratAdmin(userCtx, stratId) || isAdmin(userCtx)),
  },
  ExpertsReturn: {
    isStatusOk: (status) => [RS.onApproveExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId) => stratId && isAdmin(userCtx),
  },
  ExpertsApproveBySP: {
    isStatusOk: (status) => [RS.onApproveHeadSP].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => stratId && (isStratAdmin(userCtx, stratId) || isAdmin(userCtx)),
    extra: (status, userCtx, stratId, projId, portfId) =>
      portfId && status === RS.onApproveHeadSP && (isStratAdmin(userCtx, stratId) || isAdmin(userCtx)), // у портфельных проектов РСП сразу одобряет проект (нет статуса рассмотрения ЭГ)
  },
  ExpertsApprove: {
    isStatusOk: (status) => [RS.onApproveExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => stratId && isAdmin(userCtx),
    extra: (status, userCtx, stratId, projId, portfId, policyId) =>
      !portfId && status === RS.onApproveExperts && isAdmin(userCtx),
  },
  ExpertsDecline: {
    isStatusOk: (status) => [RS.onApproveExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId) => stratId && isAdmin(userCtx),
  },
  ApproveFinal: {
    isStatusOk: (status) => true,
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  SeeExpertsApproved: {
    isStatusOk: (status) => [RS.onApproveExperts, RS.expertsApproved, RS.expertsDeclined, RS.approved].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId, policyId) => stratId && (isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx)),
  },
  CloseProj: {
    isStatusOk: (status) => [RS.expertsApproved, RS.approved].includes(status),
    isRoleOk: (userCtx) => isAdmin(userCtx),
    extra: (status, userCtx, stratId, projId, portfId, projStatus) => ![PS.onApproveHeadSP, PS.onApproveExperts, PS.onApprovePortf, PS.onApproveCommittee].includes(projStatus),
  },
};

export const getActionsModel = (status, userCtx, stratId, projId, portfId, policyId, projStatus) => Object.entries(rules).reduce((acc, [key, rule]) => ({
  ...acc,
  [key]: rule.isStatusOk(status) && rule.isRoleOk(userCtx, stratId, projId, portfId, policyId) && (!rule.extra || rule.extra(status, userCtx, stratId, projId, portfId, policyId, projStatus)),
}), {});
